export const REQUEST_SERVICELEVEL_DATA = "REQUEST_SERVICELEVEL_DATA";
export const RECEIVE_SERVICELEVEL_DATA = "RECEIVE_SERVICELEVEL_DATA";

export const requestServiceLevelData = () => ({
  type: REQUEST_SERVICELEVEL_DATA
});

export const receiveServiceLevelData = payload => ({type: RECEIVE_SERVICELEVEL_DATA, payload: payload});


// WEBPACK FOOTER //
// ./src/actions/serviceLevelDataActions.js